import { get } from '../request';
import { APP_CONFIG } from '../../config';
import type { SolvencyRes } from '../../@types/productsStatus';
import { ApiEndpoints } from '../apiEndpoints.constant';
import type { SolvencyInfoResponse } from '@/@types/solvency';

export const getSchufaStatus = async (): Promise<SolvencyRes> => {
  return await get(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.schufaStatus}`);
};

export const getIs24SolvencyStatus = async (): Promise<SolvencyRes> => {
  return await get(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.is24SolvencyStatus}`);
};

export const getSolvencyInfo = async (): Promise<SolvencyInfoResponse> => {
  return await get(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.solvencyInfo}`);
};
